export { default } from './page-card';
